import { createRouter, createWebHashHistory } from 'vue-router';

// Import the views
import HomePage from '../js/VueComponents/Views/Home.vue';
import JobsPage from '../js/VueComponents/Views/Jobs.vue';
import LoginPage from '../js/VueComponents/Views/Login.vue';
import JobDetailsPage from '../js/VueComponents/Views/JobDetails.vue';
import RegistrationPage from '../js/VueComponents/Views/Registration.vue';
import ApplicantProfilePage from '../js/VueComponents/Views/ApplicantProfile.vue';

// Define your routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/Index',
    name: 'Index',
    component: HomePage
  },
  {
    path: '/Jobs',
    name: 'Jobs',
    component: JobsPage
  },
  {
    path: '/Login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/JobDetails',
    name: 'Job Details Page',
    component: JobDetailsPage
  },
  {
    path: '/Registration',
    name: 'Registration Page',
    component: RegistrationPage
  },
  {
    path: '/ApplicantProfile',
    name: 'Applicant Profile Page',
    component: ApplicantProfilePage
  }
];

// Create the Vue Router instance
const router = createRouter({
  history: createWebHashHistory(),  // Use history mode (clean URLs)
  routes
});

export default router;
